import React, { useState } from "react";

import { kindColorOf, kindLabelOf } from "./homeUtils";

// 과제 표지. 문제지 첫 쪽(cover_url)이 있으면 그 그림을, 없으면 종류 색 바탕에 이름을 적은 글자 표지를 그린다.
// 종류 색은 교사 화면 · 과제 목록 이름표(typeInfo)와 같은 색이다.
const HomeCover = ({ item, badge, badgeTone, progress }) => {
  const [isBroken, setIsBroken] = useState(false);
  const coverUrl = item.cover_url && !isBroken ? item.cover_url : "";
  const kindColor = kindColorOf(item.type);

  return (
    <div className="home-cover">
      {coverUrl ? (
        <img className="home-cover__image" src={coverUrl} alt="" loading="lazy" onError={() => setIsBroken(true)} />
      ) : (
        // 종류 색은 typeInfo 에서 오는 런타임 값이라 인라인으로 둔다
        <div className="home-cover__text" style={{ backgroundColor: kindColor.backgroundColor, color: kindColor.color }}>
          <span className="home-cover__kind">{kindLabelOf(item)}</span>
          <span className="home-cover__title">{item.title}</span>
        </div>
      )}
      {badge && <span className={`home-cover__badge home-cover__badge--${badgeTone || "calm"}`}>{badge}</span>}
      {progress !== undefined && (
        <span className="home-cover__progress">
          <i style={{ width: `${progress}%` }} />
        </span>
      )}
    </div>
  );
};

export default HomeCover;
